module.exports = __webpack_public_path__ + "img/linux.9add49e1.png";